import { render, staticRenderFns } from "./VSettingsPolicy.vue?vue&type=template&id=084c95c4&"
import script from "./VSettingsPolicy.vue?vue&type=script&lang=js&"
export * from "./VSettingsPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports